import { handleActions, combineActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.openTrainingSettingsDialog](state, action) {
      return true
    },
    [combineActions(rawActions.closeTrainingSettingsDialog, rawActions.trainProject.request)](state, action) {
      return false
    },
  },
  defaultState
)
